"use client";
import React, { useState, useEffect } from 'react';
import './loader.css';

const Loader = ({
  size = 'medium',
  color = 'primary',
  text = 'جاري التحميل...',
  showText = true,
  overlay = false
}) => {
  const [isTimeout, setIsTimeout] = useState(false);

  useEffect(() => {
    // Set a timeout to show error message after 5 seconds
    const timer = setTimeout(() => {
      setIsTimeout(true);
    }, 5000);

    // Clear timeout on unmount
    return () => clearTimeout(timer);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const sizeClasses = {
    small: 'spinner-sm',
    medium: 'spinner-md',
    large: 'spinner-lg'
  };

  const colorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    success: 'text-success',
    danger: 'text-danger',
    warning: 'text-warning',
    info: 'text-info',
    light: 'text-light',
    dark: 'text-dark'
  };

  if (isTimeout) {
    const timeoutContent = (
      <div className="text-center fade-in-up">
        <div className="mb-3 text-warning">
          <i className="bi bi-exclamation-circle" style={{ fontSize: '2rem' }}></i>
        </div>
        <p className="loading-text text-dark mb-3">كرماً، أعد المحاولة 🙏</p>
        <button
          className="btn btn-dark btn-sm rounded-pill px-4"
          onClick={handleReload}
        >
          <i className="bi bi-arrow-clockwise me-2"></i>
          تحديث
        </button>
      </div>
    );

    if (overlay) {
      return (
        <div className="loading-overlay">
          <div className="loading-content">
            {timeoutContent}
          </div>
        </div>
      );
    }

    return (
      <div className="loading-container">
        {timeoutContent}
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loading-overlay">
        <div className="loading-content">
          <div className={`spinner-border ${colorClasses[color]} ${sizeClasses[size]}`} role="status">
            <span className="visually-hidden">{text}</span>
          </div>
          {showText && <p className="loading-text mt-3">{text}</p>}
        </div>
      </div>
    );
  }



  return (
    <div className="loading-container">
      <div className={`spinner-border ${colorClasses[color]} ${sizeClasses[size]}`} role="status">
        <span className="visually-hidden">{text}</span>
      </div>
      {showText && <p className="loading-text mt-3">{text}</p>}
    </div>
  );
};

export default Loader;
